import { render, staticRenderFns } from "./ViewContentRepeater.vue?vue&type=template&id=be3dc718"
import script from "./ViewContentRepeater.vue?vue&type=script&lang=js"
export * from "./ViewContentRepeater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports